'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var useBooleanState_hook = require('./use-boolean-state.hook-8d04931f.js');
var useOnClickOutside_hook = require('./use-on-click-outside.hook-0ab21de9.js');
var component$w = require('./component-b1f064dd.js');

var MIN_TRANSLATE_Y = 0;
var userActionStartValues = {
    translateY: 0,
    touchY: 0,
    moveItemCount: 0,
    animationTimer: null,
};
var getPageY = function (event) {
    if (event instanceof MouseEvent) {
        return event.pageY || event.clientY;
    }
    return event.targetTouches[0].pageY;
};
var calculateCurrentTranslateY = function (touchY, maxTranslateY) {
    var offsetY = touchY - userActionStartValues.touchY;
    var currentTranslateY = userActionStartValues.translateY + offsetY;
    if (-currentTranslateY > maxTranslateY) {
        currentTranslateY = -maxTranslateY;
    }
    if (-currentTranslateY < MIN_TRANSLATE_Y) {
        currentTranslateY = MIN_TRANSLATE_Y;
    }
    return currentTranslateY;
};
var calculateItemValues = function (touchY, itemHeight, itemsLength) {
    var maxTranslateY = itemHeight * (itemsLength - 1);
    var currentTranslateY = calculateCurrentTranslateY(touchY, maxTranslateY);
    var newCurrentIndex = -Math.round(currentTranslateY / itemHeight);
    return { newCurrentIndex: newCurrentIndex, currentTranslateY: currentTranslateY };
};
var useAnimation = function () {
    var _a = useBooleanState_hook.useBooleanState(false), isAnimating = _a.value, startAnimation = _a.setTrue, stopAnimation = _a.setFalse;
    var animate = React.useCallback(function () {
        startAnimation();
        userActionStartValues.animationTimer = setTimeout(function () {
            stopAnimation();
        }, 200);
    }, [startAnimation, stopAnimation]);
    var cancelAnimation = React.useCallback(function () {
        clearTimeout(userActionStartValues.animationTimer);
        stopAnimation();
    }, [stopAnimation]);
    return { isAnimating: isAnimating, animate: animate, cancelAnimation: cancelAnimation };
};
var useWheelPickerValues = function (items, itemHeight, onChange, defaultValue) {
    var _a = tslib_es6.__read(React.useState(0), 2), currentIndex = _a[0], setCurrentIndex = _a[1];
    var _b = tslib_es6.__read(React.useState(0), 2), translateY = _b[0], setTranslateY = _b[1];
    var setSelectedItemValues = React.useCallback(function (selecteditemIndex, newTranslateY) {
        setCurrentIndex(selecteditemIndex);
        setTranslateY(newTranslateY);
    }, [setCurrentIndex, setTranslateY]);
    var calculateSelectedItemValues = React.useCallback(function (touchY) { return (calculateItemValues(touchY, itemHeight, items.length)); }, [items.length, itemHeight]);
    React.useEffect(function () {
        if (defaultValue) {
            var defaultValueIndex = items.findIndex(function (_a) {
                var value = _a.value;
                return value.toString() === defaultValue.toString();
            });
            if (defaultValueIndex !== -1) {
                setSelectedItemValues(defaultValueIndex, -defaultValueIndex * itemHeight);
                onChange(items[defaultValueIndex].value);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return {
        currentIndex: currentIndex, translateY: translateY, setSelectedItemValues: setSelectedItemValues, calculateSelectedItemValues: calculateSelectedItemValues,
    };
};
var useWheelPickerActions = function (items, itemHeight, onChange, animate, setSelectedItemValues, calculateSelectedItemValues, translateY) {
    var _a = useBooleanState_hook.useBooleanState(false), isScrolling = _a.value, setIsScrollingTrue = _a.setTrue, setIsScrollingFalse = _a.setFalse;
    var handleStart = React.useCallback(function (event) {
        userActionStartValues.touchY = getPageY(event);
        userActionStartValues.translateY = translateY;
        userActionStartValues.moveItemCount = 0;
    }, [translateY]);
    var handleMove = React.useCallback(function (event) {
        setIsScrollingTrue();
        var _a = calculateSelectedItemValues(getPageY(event)), newCurrentIndex = _a.newCurrentIndex, currentTranslateY = _a.currentTranslateY;
        setSelectedItemValues(newCurrentIndex, currentTranslateY);
    }, [calculateSelectedItemValues, setSelectedItemValues, setIsScrollingTrue]);
    var handleEnd = React.useCallback(function (selectedDateIndex) {
        var currentTranslateY = -selectedDateIndex * itemHeight;
        setSelectedItemValues(selectedDateIndex, currentTranslateY);
        onChange(items[selectedDateIndex].value);
        animate();
        setTimeout(function () { return setIsScrollingFalse(); }, 0);
    }, [itemHeight, setSelectedItemValues, onChange, items, animate, setIsScrollingFalse]);
    return { wheelPickerActions: { handleStart: handleStart, handleMove: handleMove, handleEnd: handleEnd }, isScrolling: isScrolling };
};
var useWheelPickerTouchEvents = function (isAnimating, currentIndex, _a) {
    var handleStart = _a.handleStart, handleMove = _a.handleMove, handleEnd = _a.handleEnd;
    var handleTouchEnd = React.useCallback(function () {
        if (isAnimating)
            return;
        handleEnd(currentIndex);
    }, [isAnimating, currentIndex, handleEnd]);
    var handleTouchStart = React.useCallback(function (event) {
        if (isAnimating)
            return;
        handleStart(event);
    }, [isAnimating, handleStart]);
    var handleTouchMove = React.useCallback(function (event) {
        if (isAnimating)
            return;
        handleMove(event);
    }, [isAnimating, handleMove]);
    return { handleTouchStart: handleTouchStart, handleTouchMove: handleTouchMove, handleTouchEnd: handleTouchEnd };
};
var useWheelPickerMouseEvents = function (isAnimating, _a, calculateSelectedItemValues) {
    var handleStart = _a.handleStart, handleMove = _a.handleMove, handleEnd = _a.handleEnd;
    var handleMouseEnd = React.useCallback(function (event) {
        var newCurrentIndex = calculateSelectedItemValues(getPageY(event)).newCurrentIndex;
        handleEnd(newCurrentIndex);
    }, [calculateSelectedItemValues, handleEnd]);
    var handleMouseUp = React.useCallback(function (event) {
        handleMouseEnd(event);
        document.removeEventListener('mousemove', handleMove);
        document.removeEventListener('mouseup', handleMouseUp);
    }, [handleMouseEnd, handleMove]);
    var handleMouseDown = React.useCallback(function (event) {
        if (isAnimating)
            return;
        handleStart(event);
        document.addEventListener('mousemove', handleMove);
        document.addEventListener('mouseup', handleMouseUp);
    }, [isAnimating, handleStart, handleMove, handleMouseUp]);
    return handleMouseDown;
};
var useWheelPickerScollEvents = function (items, isAnimating, currentIndex, handleEnd, cancelAnimation) {
    var handleScroll = React.useCallback(function (event) {
        if (isAnimating) {
            cancelAnimation();
        }
        var newCurrentIndex = currentIndex;
        if (event.deltaY > 0 && currentIndex < items.length - 1) {
            newCurrentIndex = currentIndex + 1;
        }
        if (event.deltaY < 0 && currentIndex > 0) {
            newCurrentIndex = currentIndex - 1;
        }
        if (newCurrentIndex === currentIndex) {
            return;
        }
        handleEnd(newCurrentIndex);
    }, [currentIndex, items, isAnimating, handleEnd, cancelAnimation]);
    return handleScroll;
};
var useWheelPickerEventHandlers = function (items, itemHeight, onChange, defaultValue) {
    var _a = useWheelPickerValues(items, itemHeight, onChange, defaultValue), currentIndex = _a.currentIndex, translateY = _a.translateY, setSelectedItemValues = _a.setSelectedItemValues, calculateSelectedItemValues = _a.calculateSelectedItemValues;
    var _b = useAnimation(), isAnimating = _b.isAnimating, animate = _b.animate, cancelAnimation = _b.cancelAnimation;
    var _c = useWheelPickerActions(items, itemHeight, onChange, animate, setSelectedItemValues, calculateSelectedItemValues, translateY), wheelPickerActions = _c.wheelPickerActions, isScrolling = _c.isScrolling;
    var touchEventHandlers = useWheelPickerTouchEvents(isAnimating, currentIndex, wheelPickerActions);
    var handleMouseDown = useWheelPickerMouseEvents(isAnimating, wheelPickerActions, calculateSelectedItemValues);
    var handleEnd = wheelPickerActions.handleEnd;
    var handleScroll = useWheelPickerScollEvents(items, isAnimating, currentIndex, handleEnd, cancelAnimation);
    return tslib_es6.__assign(tslib_es6.__assign({}, touchEventHandlers), { handleMouseDown: handleMouseDown,
        isAnimating: isAnimating,
        items: items,
        currentIndex: currentIndex,
        translateY: translateY,
        handleScroll: handleScroll,
        isScrolling: isScrolling });
};

var useWheelPicker = function (items, itemHeight, onChange, onClickOutside, defaultValue) {
    var viewportRef = React.useRef(null);
    var _a = useWheelPickerEventHandlers(items, itemHeight, onChange, defaultValue), handleTouchStart = _a.handleTouchStart, handleTouchMove = _a.handleTouchMove, handleTouchEnd = _a.handleTouchEnd, handleMouseDown = _a.handleMouseDown, handleScroll = _a.handleScroll, currentIndex = _a.currentIndex, restWheelPickerValues = tslib_es6.__rest(_a, ["handleTouchStart", "handleTouchMove", "handleTouchEnd", "handleMouseDown", "handleScroll", "currentIndex"]);
    var handleDone = React.useCallback(function () {
        // eslint-disable-next-line no-unused-expressions
        onChange === null || onChange === void 0 ? void 0 : onChange(items[currentIndex].value);
        // eslint-disable-next-line no-unused-expressions
        onClickOutside === null || onClickOutside === void 0 ? void 0 : onClickOutside();
    }, [currentIndex, items, onChange, onClickOutside]);
    React.useEffect(function () {
        var viewport = viewportRef.current;
        if (viewport) {
            viewport.addEventListener('touchstart', handleTouchStart);
            viewport.addEventListener('touchmove', handleTouchMove);
            viewport.addEventListener('touchend', handleTouchEnd);
            viewport.addEventListener('mousedown', handleMouseDown);
            viewport.addEventListener('wheel', handleScroll);
        }
        return function () {
            if (viewport) {
                viewport.removeEventListener('touchstart', handleTouchStart);
                viewport.removeEventListener('touchmove', handleTouchMove);
                viewport.removeEventListener('touchend', handleTouchEnd);
                viewport.removeEventListener('mousedown', handleMouseDown);
                viewport.removeEventListener('wheel', handleScroll);
            }
        };
    }, [handleTouchStart, handleTouchMove, handleTouchEnd, handleMouseDown, handleScroll]);
    return tslib_es6.__assign(tslib_es6.__assign({}, restWheelPickerValues), { currentIndex: currentIndex, viewportRef: viewportRef, handleDone: handleDone });
};
var useWheelPickerOutsideClick = function (_a) {
    var outsideClickRef = _a.outsideClickRef, onClickOutside = _a.onClickOutside, isScrolling = _a.isScrolling;
    var wheelPickerRef = React.useRef(null);
    useOnClickOutside_hook.useOnClickOutside(function () {
        if (onClickOutside && !isScrolling) {
            onClickOutside();
        }
    }, [outsideClickRef || wheelPickerRef]);
    return wheelPickerRef;
};

var WheelPicker = function (_a) {
    var items = _a.items, defaultValue = _a.defaultValue, _b = _a.width, width = _b === void 0 ? 240 : _b, _c = _a.height, height = _c === void 0 ? 210 : _c, _d = _a.itemHeight, itemHeight = _d === void 0 ? 30 : _d, onChange = _a.onChange, onItemClick = _a.onItemClick, outsideClickParams = _a.outsideClickParams, _e = _a.outsideClickParams, _f = _e === void 0 ? {} : _e, onClickOutside = _f.onClickOutside, className = _a.className, doneButton = _a.doneButton;
    var _g = useWheelPicker(items, itemHeight, onChange, onClickOutside, defaultValue), isAnimating = _g.isAnimating, currentIndex = _g.currentIndex, translateY = _g.translateY, viewportRef = _g.viewportRef, isScrolling = _g.isScrolling, handleDone = _g.handleDone;
    var wheelPickerRef = useWheelPickerOutsideClick(tslib_es6.__assign(tslib_es6.__assign({}, outsideClickParams), { isScrolling: isScrolling }));
    return (React__default.createElement(component$w.Container, { ref: wheelPickerRef, width: width, className: className + "-container", "data-testid": "wheel-picker-container" },
        React__default.createElement(component$w.WheelPickerViewport, { ref: viewportRef, height: height, "data-testid": "wheel-picker-viewport", className: "wheel-picker-viewport" },
            React__default.createElement(component$w.WheelPickerWrapper, { height: itemHeight },
                React__default.createElement(component$w.WheelPickerItemsList, { onClick: onItemClick, items: items, itemHeight: itemHeight, currentIndex: currentIndex, isAnimating: isAnimating, translateY: translateY, isScrolling: isScrolling }))),
        doneButton && React__default.createElement(component$w.ButtonStyled, { variant: "link", text: doneButton, onClick: handleDone })));
};

exports.WheelPicker = WheelPicker;
